import type { ReactNode } from "react";

import { cx } from "../lib/format";

export interface EmptyStateProps {
  title: string;
  description?: string;
  /** One primary action — keep empty states to a single next step. */
  action?: ReactNode;
  icon?: ReactNode;
  className?: string;
}

export function EmptyState({ title, description, action, icon, className }: EmptyStateProps) {
  return (
    <div
      className={cx(
        "flex flex-col items-center justify-center gap-3 rounded border border-dashed border-line px-6 py-16 text-center",
        className,
      )}
    >
      {icon && <div className="text-muted">{icon}</div>}
      <h3 className="font-display text-lg tracking-display text-bright">{title}</h3>
      {description && <p className="max-w-sm text-sm text-muted">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
